import { create } from 'zustand'

export interface Portfolio {
  id: string
  name: string
  baseCurrency: string
  initialCapital: number
  createdAt: string
  updatedAt: string
}

export interface PortfolioSummary {
  portfolioId: string
  name: string
  totalPnl: number
  totalPnlPct: number
  currentDrawdown: number
  maxDrawdown: number
  winRate: number
  totalTrades: number
  openTrades: number
}

export interface EquityPoint {
  timestamp: string
  equity: number
  drawdownPct: number
}

interface PortfolioState {
  portfolios: Portfolio[]
  selectedPortfolioId: string | null
  summary: PortfolioSummary | null
  equityCurve: EquityPoint[]

  setPortfolios: (portfolios: Portfolio[]) => void
  selectPortfolio: (id: string) => void
  setSummary: (summary: PortfolioSummary) => void
  setEquityCurve: (curve: EquityPoint[]) => void
  reset: () => void
}

export const usePortfolioStore = create<PortfolioState>((set) => ({
  portfolios: [],
  selectedPortfolioId: null,
  summary: null,
  equityCurve: [],

  setPortfolios: (portfolios) => set({ portfolios }),

  selectPortfolio: (id) =>
    set({ selectedPortfolioId: id, summary: null, equityCurve: [] }),

  setSummary: (summary) => set({ summary }),

  setEquityCurve: (equityCurve) => set({ equityCurve }),

  reset: () =>
    set({
      portfolios: [],
      selectedPortfolioId: null,
      summary: null,
      equityCurve: [],
    }),
}))
